import { render } from "./CategoryMessage.vue?vue&type=template&id=57e1e182&lang=pug"
import script from "./CategoryMessage.vue?vue&type=script&lang=js"
export * from "./CategoryMessage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__